var exports = {
  "PY": "cardLabel__i-NAdk",
  "YL": "tooltip__puZs47",
  "cz": "ReviewersToken__aI03D6",
  "qB": "progress__3pC9C1",
  "Dd": "bottomProgress__FTP4Xg",
};

module.exports = exports;
